export const TypesDetalheISO = {
    BUSCARISO: "BUSCARISO",
    RESET: "RESET"
}

const INITIAL = {
    $id: 0,
    Sucesso: false,
    Mensagem: "",
    ISO: "",
    ISODetalhes: "",
    TipoContainer: "",
    TaraMaxima: 0,
    TaraMinima: 0,
    TaraMaximaAviso: 0,
    HabilitaExcedenteCasoCheio: false
}

export default function detalheISOReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesDetalheISO.BUSCARISO:
            return {
                ...state,
                $id: action.payload.$id,
                Sucesso: action.payload.Sucesso,
                Mensagem: action.payload.Mensagem,
                ISO: action.payload.ISO,
                ISODetalhes: action.payload.ISODetalhes,
                TipoContainer: action.payload.TipoContainer,
                TaraMaxima: action.payload.TaraMaxima,
                TaraMinima: action.payload.TaraMinima,
                TaraMaximaAviso: action.payload.TaraMaximaAviso,
                HabilitaExcedenteCasoCheio: action.payload.HabilitaExcedenteCasoCheio
            };
        case TypesDetalheISO.RESET:
            return INITIAL;
        default:
            return state;
    }
}

export const DetalheISOActions = {
    buscarISO,
    resetState
}

function buscarISO(dadosISO) {

    return {
        type: TypesDetalheISO.BUSCARISO,
        payload: dadosISO
    }
}

function resetState() {
    return { type: "RESET" }
}